"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "m19.6469 9.6403-.0037.0011c-.1614-.5281.1358-1.0872.664-1.2487.5209-.1592 1.072.1279 1.2418.6426l.0039-.0012A9.9977 9.9977 0 0 1 22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c.5523 0 1 .4477 1 1s-.4477 1-1 1c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8 8-3.5817 8-8a8 8 0 0 0-.3531-2.3597Z", clipRule: "evenodd" })), 'LoaderIcon');
